import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import { URL_BASE, LOCAL_STORAGE_KEY } from './const/general';

import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from './hooks/use-auth';
import { LEFT_MENU_PREF_SHINNKO_CITY_INDEX } from './const/data_index';

const PrivateRoute = (props) => {
    const { isAuthenticated, isLoading } = useContext(AuthContext);
    const lastAuthUser = localStorage.getItem(`${LOCAL_STORAGE_KEY.PREFIX}.${LOCAL_STORAGE_KEY.CLI_ID}.${LOCAL_STORAGE_KEY.LAST_AUTH}`);
    const idToken = localStorage.getItem(`${LOCAL_STORAGE_KEY.PREFIX}.${LOCAL_STORAGE_KEY.CLI_ID}.${lastAuthUser}.${LOCAL_STORAGE_KEY.ID_TOKEN}`);

    // APIに含めるクエリパラメータの作成
    const params = new URLSearchParams();
    props.prefCode.forEach((code) => params.append('pref_code', code));

    useEffect(() => {
        // ロード中は何もしない
        if (isLoading || !props.prefCode || props.prefCode.length === 0) return;

        // 市区町村の取得
        axios
            .get(URL_BASE + `api/get_city?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${idToken}`,
                },
            })
            .then((res) => {
                props.setCitys(res.data);
                const allCityCodes = res.data.map((obj) => obj[LEFT_MENU_PREF_SHINNKO_CITY_INDEX.CITY_CODE]);
                const city_codes = props.defaultCities.length === 0 ? allCityCodes : allCityCodes.filter((code) => props.defaultCities.includes(code.toString()));
                props.setSelectCitys(city_codes);

                // 市区町村の取得に成功したら被害報告カテゴリーも取得
                // axios.get(URL_BASE + 'api/get_chronology_category/',
                //   {
                //     method: 'GET',
                //     headers: {
                //       'Content-Type': 'application/json',
                //       Authorization: `Bearer ${idToken}`,
                //     },
                //   }
                // ).then(res => {
                //   props.setChronologyCategory(res.data)
                //   const category_codes = res.data.map(obj => obj[LEFT_MENU_PREF_SHINNKO_CITY_INDEX.CITY_CODE]);
                //   props.setSelectChronologyCategory(category_codes)
                //   // 被害報告カテゴリーの取得に成功したら避難所開設状況も取得
                //   axios.get(URL_BASE + 'api/get_shelter_status/',
                //     {
                //       method: 'GET',
                //       headers: {
                //         'Content-Type': 'application/json',
                //         Authorization: `Bearer ${idToken}`,
                //       },
                //     }
                //   ).then(res => {
                //     props.setShelterStatus(res.data)
                //     const shelter_status_codes = res.data.map(obj => obj[LEFT_MENU_PREF_SHINNKO_CITY_INDEX.CITY_CODE]);
                //     props.setSelectShelterStatus(shelter_status_codes)

                //     // 避難所開設状況の取得に成功したら鉄道リストも取得
                //     axios.get(URL_BASE + 'api/get_rails/',
                //       {
                //         method: 'GET',
                //         headers: {
                //           'Content-Type': 'application/json',
                //           Authorization: `Bearer ${idToken}`,
                //         },
                //       }
                //     ).then(res => {
                //       props.setRails(res.data)
                //       const txt_rail_names = res.data.map(obj => obj[LEFT_MENU_PREF_SHINNKO_CITY_INDEX.CITY_CODE]);
                //       props.setSelectRails(txt_rail_names)
                //     }).catch(err => {
                //       console.log(err);
                //     })

                //   }).catch(err => {
                //     console.log(err);
                //   })

                // }).catch(err => {
                //   console.log(err);
                // })
            })
            .catch((err) => {
                console.log(err);
            });
    }, [isLoading]);

    return isAuthenticated || (idToken && idToken !== 'undefined') ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
